// src/js/shared/http-requests/BaseRequest.js

import axios from 'axios';
import { Store } from '../../store';

export function getApiUrl() {
    return (process.env.REACT_APP_API_URL_DINAMICA === 'true' ?
        window.location.origin : process.env.REACT_APP_URL) || '';
}

// Cria a instância principal do axios
const _axiosInst = axios.create({
    baseURL: getApiUrl(),
    headers: {
        post: { Accept: 'application/json' },
        Accept: 'application/json',
    },
});

// Função para refresh token privado
async function refreshToken() {
    const state = Store.getState();
    const privateCredentials =
        state.auth.credentials || state.authPersist.credentials;

    const req = await _axiosInst.post(`/login`, {
        grant_type: 'refresh_token',
        scope: '',
        refresh_token: privateCredentials.refresh,
    });
    return req.data;
}

// Injeta as funções de renovação no interceptor de forma lazy
let interceptorApplied = false;
function applyInterceptor() {
    if (!interceptorApplied) {
            import('./interceptor/AuthInterceptor').then(module => {
                const interceptor = module.default;
                _axiosInst.interceptors.response.use(
                    undefined,
                    interceptor(_axiosInst, { refreshToken })
                );
                interceptorApplied = true;
            }).catch(error => {
                /* eslint-disable-next-line no-console */
                console.warn('Failed to load interceptor:', error);
            });
    }
}

applyInterceptor();

// Métodos utilitários
function toQueryString(params) {
    const u = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        u.append(key, value);
    });
    return u.toString();
}

const BaseRequest = {
    axiosInst: _axiosInst,
    refreshToken,
    toQueryString,

    get publicHeaders() {
        return {
            Accept: 'application/json, text/plain, */*',
            lang: this.language,
        };
    },

    get language() {
        const language = localStorage.getItem('i18nextLng');
        switch (language) {
            case 'en': return 5;
            case 'es': return 3;
            default: return 1;
        }
    },

    get privateHeaders() {
        const state = Store.getState();
        const privateCredentials = state.auth.credentials
            ? state.auth.credentials
            : state.authPersist.credentials;

        if (!privateCredentials) return null;
        const auth = { Authorization: `Bearer ${privateCredentials.token}` };
        const ret = {
            lang: this.language,
            ...auth,
        };
        return () => ret;
    },

    get privateOrPublicHeaders() {
        const state = Store.getState();
        const privateCredentials = state.auth.credentials
            ? state.auth.credentials
            : state.authPersist.credentials;

        let auth = {};

        if (privateCredentials) {
            auth = { Authorization: `Bearer ${privateCredentials.token}` };
        }
        const ret = {
            lang: this.language,
            ...auth,
        };
        return () => ret;
    },
};

export default BaseRequest;
